module.exports = __webpack_public_path__ + "public/SiteIcons/faqSiteicon2.png?becbab44";